module.exports = __webpack_public_path__ + "media/newstyle/images/facebook-304a9de5a3d0b1a68ed220940383f9b0.svg";